module.exports = __webpack_public_path__ + "static/media/PMActivo.92713af7.svg";